var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPayidSignifier40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0002 0.0001 40 0.0001 40 40 0.0002 40"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "payid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0002,20.0001 C40.0002,31.0451 31.0452,40.0001 20.0002,40.0001 C8.9542,40.0001 0.0002,31.0451 0.0002,20.0001 C0.0002,8.9541 8.9542,0.0001 20.0002,0.0001 C31.0452,0.0001 40.0002,8.9541 40.0002,20.0001",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.9309,11.8595 L19.8859,11.7435 C19.9669,11.7345 21.8899,11.5085 24.1169,11.9765 C27.1979,12.6235 29.3789,14.2795 30.4269,16.7655 L28.4249,17.6085 C26.9979,14.2225 22.9569,13.8385 21.1029,13.8535 L21.1029,23.9305 L18.9309,23.9305 L18.9309,11.8595 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0734,13.2369 C12.0734,12.3409 12.8004,11.6129 13.6974,11.6129 C14.5934,11.6129 15.3204,12.3409 15.3204,13.2369 C15.3204,14.1339 14.5934,14.8609 13.6974,14.8609 C12.8004,14.8609 12.0734,14.1339 12.0734,13.2369",
    id: "Fill-6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9592,22.4854 C30.8412,23.2544 30.6632,23.9454 30.4352,24.4824 C28.9632,27.9384 25.5322,29.6914 20.2392,29.6914 L12.5352,29.6914 L12.5352,17.6994 L14.7082,17.6994 L14.7082,27.5184 L20.2392,27.5184 C24.5802,27.5184 27.3372,26.2104 28.4362,23.6314 C28.5632,23.3314 28.6722,22.9344 28.7562,22.4834 L26.9562,22.4814 L30.0562,18.5894 L33.1632,22.4874 L30.9592,22.4854 Z",
    id: "Fill-8",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPayidSignifier40);
export default __webpack_public_path__ + "static/media/logoPayidSignifier40.f43b8e61125eb2a6f65139809cca4c1b.svg";
export { ForwardRef as ReactComponent };